import { LocalizationProvider } from '@/context/useLocalization';
import { ThemeProvider } from '@/context/useTheme';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FilteredEllipse from '@/assets/svg/Blur';
import { useEffect } from 'react';

const Layout = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 30 });
    }, [pathname]);
    return (
        <ThemeProvider>
            <LocalizationProvider>
                <div className="flex flex-col min-h-screen overflow-x-hidden relative">
                    {/* <FilteredEllipse /> */}
                    <Header />
                    <div className="h-full flex-grow">
                        <Outlet />
                    </div>
                    <Footer />
                </div>
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default Layout;
